import React, { useCallback } from 'react';
import Select from 'react-select';

const SelectInput = ({ fieldKey, label, value, setInput, options = [], isDisabled }) => {
  const handleSetInputValue = useCallback(
    (option) => {
      setInput(fieldKey, option);
    },
    [setInput, fieldKey]
  );
  return (
    <Select
      placeholder={label}
      onChange={handleSetInputValue}
      getOptionLabel={(field) => field.label}
      getOptionValue={(field) => field.value}
      value={isDisabled ? '' : [value]}
      options={options}
      styles={{
        control: (base) => ({
          ...base,
          minWidth: '130px',
          maxWidth: '225px',
        }),
      }}
      isDisabled={isDisabled}
      className="inline-select"
    />
  );
};

export default SelectInput;
